import { render, staticRenderFns, recyclableRender, components } from "./merchantActivityItem.vue?vue&type=template&id=a3c54234&scoped=true&"
var renderjs
import script from "./merchantActivityItem.vue?vue&type=script&lang=js&"
export * from "./merchantActivityItem.vue?vue&type=script&lang=js&"
import style0 from "./merchantActivityItem.vue?vue&type=style&index=0&id=a3c54234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c54234",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/merchant/merchantActivityItem.vue"
export default component.exports